module.exports = __webpack_public_path__ + "static/media/avatar-5.bbafb5ce.jpg";